import { schema } from 'normalizr';

// Example data response
const marketsHelper = markets => {
  let pairs = [];
  const exchanges = Object.keys(markets);
  exchanges.forEach(exchange => {
    const tickers = Object.keys(markets[exchange]);
    tickers.forEach(ticker => {
      pairs.push(
        Object.assign({ exchange, ticker }, markets[exchange][ticker]),
      );
    });
  });
  return pairs;
};

// Objects
const channel = new schema.Entity('channels', {}, { idAttribute: 'channelId' });
const message = new schema.Entity('messages', {}, { idAttribute: 'messageId' });
const user = new schema.Entity('users');
const market = new schema.Entity(
  'markets',
  {},
  {
    idAttribute: (value, parent, key) => {
      return `${value.exchange}-${value.ticker}`;
    },
  },
);
const snapshot = new schema.Entity(
  'snapshots',
  {},
  {
    idAttribute: (value, parent, key) => {
      return `${value.exchange}-${value.ticker}`;
    },
  },
);

// Relational definitions
channel.define({
  messages: [message],
});
message.define({
  channel,
});

export default {
  CHANNEL: channel,
  CHANNELS: [channel],
  MARKETS: [market],
  MESSAGE: message,
  MESSAGES: [message],
  SNAPSHOT: snapshot,
  SNAPSHOTS: [snapshot],
  USER: user,
  USERS: [user],
  marketsHelper,
};



// WEBPACK FOOTER //
// ./src/schema.js